import { TILE_WIDTH, TILE_HEIGHT } from '../views/board/TileView';

export function gridPositionToPxPosition(x: number, y: number): { x: number; y: number } {
  return {
    x: x * TILE_WIDTH,
    y: y * TILE_HEIGHT + (x % 2) * (TILE_HEIGHT / 2),
  };
}
